export function useActiveEntryFieldOfLaw() {
  const { active } = useFetchActiveEntry();

  const folId = computed(
    () =>
      active.value?.legal_text_paragraph.field_of_law_primary_id ?? undefined
  );

  const { query } = useFetchFieldOfLawById(folId);

  return { query, folId };
}
